<template>
  <el-dialog title="添加用户" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" class="dialogEdit" append-to-body>
    <el-form :model="form">
      <el-form-item label="帐号" :label-width="formLabelWidth">
        <el-input v-model="form.username" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="密码" :label-width="formLabelWidth">
        <el-input v-model="form.password" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="用户类型" :label-width="formLabelWidth">
        <el-select v-model="form.user_type" placeholder="请选择用户类型">
          <el-option label="澳门" value="0"></el-option>
          <el-option label="香港" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "movie_dialog",
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: 30,
      form: {
        username: "",
        password: "",
        user_type: "0",
      }
    };
  },
  methods: {
    show(value) {
      this.dialogVisible = true;
      if (value !== undefined) {
        this.form = Object.assign({}, value);
        this.form.user_type = this.form.user_type.toString();
      } else {
        this.form = { name: "", url:'',user_type:"0" };
      }
    },
    onSubmit() {
      var self = this;
      let params = Object.assign({}, this.form);
      this.$http.post("/admin/xzt/adduser", params).then(res => {
        self.$emit("sucess");
        this.dialogVisible = false;
      });
    }
  }
};
</script>
<style lang="less">
.dialogEdit{
    text-align:left;
}
</style>